<ng-container *ngFor="let item of items">

        <ng-container *ngxComponentOutlet="item; context: '' "></ng-container>

</ng-container>
